import { apiFetch } from './client';

const BASE = '/attributes';

/** List attribute definitions (paged). @param {{page?:number,size?:number,sort?:string,signal?:AbortSignal}} [opts] */
export const list = ({ page = 0, size = 20, sort = 'name,asc', signal } = {}) =>
  apiFetch(`${BASE}?page=${page}&size=${size}&sort=${sort}`, { signal });

/** Get an attribute definition by id. */
export const get = (id, { signal } = {}) => apiFetch(`${BASE}/${id}`, { signal });

/** Create an attribute definition. */
export const create = (body, { signal } = {}) =>
  apiFetch(BASE, { method: 'POST', body: JSON.stringify(body), signal });

/** Partial-update an attribute definition. */
export const update = (id, body, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'PATCH', body: JSON.stringify(body), signal });

/** Delete an attribute definition. */
export const remove = (id, { signal } = {}) =>
  apiFetch(`${BASE}/${id}`, { method: 'DELETE', signal });
